/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box, Button, Container, Stack, TextField, Typography,
} from '@mui/material';
import {
  BackButton,
  getFormProps, getSubmitButtonProps,
} from '@marageti/z4-lib';
import { Controller, useForm } from 'react-hook-form';
import { Partner } from '@marageti/z4-sdk/lib/travel';
import { LoadingButton } from '@mui/lab';
import { ViewProps } from './types';

const NonCompeteEditView = ({
  onCancel,
  onSubmit,
  partners,
  submissionError,
}: ViewProps) => {
  const {
    handleSubmit,
    control,
    formState: { isSubmitting, isValid },
  } = useForm();

  return (
    <Container maxWidth="sm">
      <Box sx={{
        pt: { desktop: 5, mobile: 2 },
        pb: 5,
      }}
      >
        <Stack>
          <Stack alignItems="start">
            <BackButton
              aria-label="back to trip"
              sx={{ mb: 2, padding: 0 }}
            />
            <Typography
              variant="h2"
            >
              Add Non-Compete
            </Typography>
          </Stack>
          <form name="non-compete-form" {...getFormProps(handleSubmit(onSubmit))}>
            <Stack spacing={2}>
              <Controller
                name="noCompetePartnerId"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <Autocomplete
                    options={partners}
                    getOptionLabel={(option: Partner) => option.name}
                    isOptionEqualToValue={(option: Partner, valueOption: Partner) => option.id === valueOption.id}
                    value={partners.find((partner) => partner.id === value) || null}
                    onChange={(_: any, newValue: Partner | null) => onChange(newValue ? newValue.id : '')}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Partners"
                      />
                    )}
                    fullWidth
                  />
                )}
              />
              <Stack direction="row" spacing={2}>
                <LoadingButton
                  variant="contained"
                  type="submit"
                  {...getSubmitButtonProps(isSubmitting, isValid)}
                >
                  Save
                </LoadingButton>
                <Button variant="outlined" onClick={onCancel}>Cancel</Button>
              </Stack>
            </Stack>
          </form>
          {submissionError && (
            <Alert severity="error" sx={{ mt: 4 }}>
              <AlertTitle>There was an error on our end.</AlertTitle>
              {`Code: ${submissionError.code}: ${submissionError.message}`}
              <br />
              {submissionError.id && `ID: ${submissionError.id}`}
            </Alert>
          )}
        </Stack>
      </Box>
    </Container>
  );
};

export default NonCompeteEditView;
